export default __webpack_public_path__ + "static/media/MyRiadPro-Regular.6c518fcd.OTF";